<div class="dialog-wrapper">
  <header class="dialog-wrapper__header">
    <ng-content select="header" />
  </header>

  <div class="dialog-wrapper__content">
    <ng-content />
  </div>
</div>
